import React from 'react';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';
import "../App.css";

function Calendar() {
  return (
    <div>
      <TopBar />
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h1>Calendar</h1>
        <p>This feature is currently in development.</p>
        <div style={{
          border: '1px solid #ccc',
          borderRadius: '8px',
          height: '400px',
          width: '80%',
          margin: '20px auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f9f9f9'
        }}>
          <p style={{ color: '#888' }}>Check back later for more updates.</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Calendar;